import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useUnit } from 'effector-react';
// Cross-entity auth state is consumed through the auth slice public API.
// eslint-disable-next-line local/no-same-layer-slice-alias-imports
import { $authUserId } from '~/entities/auth';
import { queryKeys } from '~/shared/api/queryKeys';
import {
    adminPayoutOrderServiceGetOrder,
    getAdminPayoutOrderServiceGetOrderUrl,
} from '~/generated/payoutBackend/order';
import { type AdminPayoutOrderServiceGetOrderParams } from '~/generated/payoutBackend/model';

type QueryOptions<Data> = Omit<UseQueryOptions<Data, Error, Data>, 'queryFn' | 'queryKey'>;
type OrderResponse = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>;

export const useOrder = (params: AdminPayoutOrderServiceGetOrderParams, options: QueryOptions<OrderResponse> = {}) => {
    const userId = useUnit($authUserId);
    const { enabled, ...queryOptions } = options;

    return useQuery<OrderResponse>({
        enabled: userId ? enabled : false,
        refetchOnWindowFocus: true,
        queryFn: () =>
            adminPayoutOrderServiceGetOrder(params, {
                context: {
                    skipErrorNotification: true,
                },
            }),
        queryKey: [queryKeys.PAYOUT_ORDER, userId, getAdminPayoutOrderServiceGetOrderUrl(params)],
        ...queryOptions,
    });
};
